/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { IMSObject, IMSId } from './ims-object';

export class CargoItemType extends IMSObject {
  static fromDto(dto: CargoItemTypDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: undefined,
        objRef: 'ims/CargoItemType'
      },
      dto.label,
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  public get name() : string {
    return this.databag.name
  }
  public set name(v : string) {
    this.databag.name = v;
  }

  public get extId() : string {
    return this.databag.extid
  }
  public set extId(v : string) {
    this.databag.extid = v;
  }

  public get sortKey() : string {
    return this.databag.sortkey
  }
  public set sortKey(v : string) {
    this.databag.sortkey = v;
  }


  public get itemValueFormated() : string {
    return this.itemValue?.toFixed(2)
  }
  public get itemValue() : number {
    return this.databag.itemvalue
  }
  public set itemValue(v : number) {
    this.databag.itemvalue = v;
  }

  public get selfSpaceSquareMetres() : number {
    return this.databag.selfspacesquaremetres
  }
  public set selfSpaceSquareMetres(v : number) {
    this.databag.selfspacesquaremetres = v;
  }

  public get selfVolumeLitres() : number {
    return this.databag.selfvolumelitres
  }
  public set selfVolumeLitres(v : number) {
    this.databag.selfvolumelitres = v;
  }

  public get selfWeightKilos() : number {
    return this.databag.selfweightkilos
  }
  public set selfWeightKilos(v : number) {
    this.databag.selfweightkilos = v;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/CargoItemType');
  }
}

export interface CargoItemTypDTO {
  id: number;
  label: string;
  name?: string;
  extid?: string;
  sortkey?: string;
  itemvalue?: number;
  selfspacesquaremetres?: number;
  selfvolumelitres?: number;
  selfweightkilos?: number;
}
